"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

/**
 * A generic element constructor which all elements can use to create their type.
 */
exports.default = function (_ref) {
    var id = _ref.id,
        location = _ref.location,
        content = _ref.content,
        modified = _ref.modified,
        meta = _ref.meta;
    return {
        id: id,
        location: location,
        content: content,
        modified: modified || new Date().getTime(),
        meta: meta
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/elements/elementConstructor.js
// module id = 173
// module chunks = 0